import { Tabs, TabsProps } from "@mui/material";
import {
  BlogNavigationTabs,
  FilterFor,
  useBlogNavigationContext,
} from "./BlogNavigationProvider";
import React from "react";
import { AppTab } from "../../../global/ui/tabs";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";

type BlogTabsProps = TabsProps;

export const BlogTabs = (props: BlogTabsProps) => {
  const { state, dispatch } = useBlogNavigationContext();
  const user = useSelector((state: RootState) => state.user.value);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    dispatch({ tab: newValue });
  };

  const handleTabClick = (filterFor: FilterFor) => {
    dispatch({ filterFor: filterFor });
  };

  return (
    <Tabs value={state.tab} onChange={handleTabChange} {...props}>
      <AppTab
        label={"Explore"}
        value={BlogNavigationTabs.EXPLORE}
        onClick={() => handleTabClick(FilterFor.EXPLORE)}
      />
      {user?.loggedUser && (
        <AppTab
          label={"Following"}
          value={BlogNavigationTabs.FOLLOWING}
          onClick={() => handleTabClick(FilterFor.FOLLOWING)}
        />
      )}
    </Tabs>
  );
};
